export default __webpack_public_path__ + "static/media/milholland-logo.68159e6a.jpg";